// JavaScript source code
import { DecryptAES, EncryptAES } from '../utils/services/authentication/AESService';
import { Claims } from '../utils/services/cache/ClientCache'

const axios = require('axios');

export const verifyJti = async (jti, studentNumber) => {
    const bodyFormData = new FormData();
    bodyFormData.set('jti', jti);
    bodyFormData.set('studentNumber', studentNumber);

    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}cryptography/VerifyJti`,
        data: bodyFormData,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response;
        })
        .catch(function (response) {
            //handle error
            console.error(response);
        });
};

export const ResetJti = (studentNumber, jti) => {
    const bodyFormData = new FormData();
    bodyFormData.set('studentNumber', studentNumber);
    bodyFormData.set('jti', jti);

    return axios({
        method: 'post',
        url: `${process.env.WEB_API}cryptography/ResetJti`,
        data: bodyFormData,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (response) {
            //handle error
            console.error(response);
        });
};

export const getServerKey = async (pubKey) => {
    const bodyFormData = new FormData();
    bodyFormData.set('pubKey', pubKey);

    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}cryptography/GetServerPublicKey`,
        data: bodyFormData,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            //handle success
            return response;
        })
        .catch(function (response) {
            //handle error
            console.error(response);
        });
};

export const getStudentAndAuthentication = async (studentNumber) => {
    const key = localStorage.getItem('aesKey');
    const iv = localStorage.getItem('aesIV');
    studentNumber = EncryptAES(studentNumber, key, iv);
    const bodyFormData = new FormData();
    bodyFormData.set('studentNumber', studentNumber);

    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}cryptography/getStudent`,
        data: bodyFormData,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            //handle success
            return response && response.data && JSON.parse(DecryptAES(response.data, key, iv));
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response && error.response.status;
        });
};

export const refreshToken = (studentNumber) => {
    let bodyFormData = new FormData();
    bodyFormData.set('studentNumber', studentNumber);
    return axios({
        method: 'post',
        url: `${process.env.WEB_API}cryptography/refreshToken`,
        data: bodyFormData,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            //handle success
            //console.log(response.data);
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
        });

};